import { OrderType, type SortOrder } from "../../types/grid.ts";

/**
 * The column sort a saved view (Manage views) brings back.
 *
 * `undefined` is a view saved before views stored their sort: it leaves the grid's current sort
 * alone, as `columns` does. `[]` is a view saved unsorted and clears the sort. Columns the report
 * no longer has are dropped, because the sort goes to the server as GetDataGrid's orderList; the
 * check is skipped while the column definitions are not loaded (`known` empty).
 */
export function sortsForView(stored: SortOrder[] | undefined, known: ReadonlySet<string>): SortOrder[] | undefined {
    if (stored === undefined) return undefined;
    if (!Array.isArray(stored)) return [];
    return stored.filter(s =>
        typeof s?.sColumnName === "string"
        && (s.OrderType === OrderType.ASC || s.OrderType === OrderType.DESC)
        && (known.size === 0 || known.has(s.sColumnName.toLowerCase())));
}

/** "Name ascending" for the view's details; null when the view stores no sort. */
export function describeViewSort(stored: SortOrder[] | undefined, displayNames: Record<string, string>): string | null {
    if (!stored?.length) return null;
    return stored
        .map(s => `${displayNames[s.sColumnName] ?? displayNames[s.sColumnName.toLowerCase()] ?? s.sColumnName} ${s.OrderType === OrderType.DESC ? "descending" : "ascending"}`)
        .join(", ");
}
